import * as tslib_1 from "tslib";
import * as React from 'react';
import { Dialog, IconButton, FontIcon } from 'material-ui';
import { cyan500 } from 'material-ui/styles/colors';
var styles = {
    title: {
        backgroundColor: cyan500,
        padding: 0,
        color: 'white',
    },
    body: {
        padding: 0,
        border: 'none'
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
};
var BoardyDialog = /** @class */ (function (_super) {
    tslib_1.__extends(BoardyDialog, _super);
    function BoardyDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function () {
            if (_this.props.onClosing) {
                _this.props.onClosing();
            }
        };
        _this.handleClose = function (e) {
            e.preventDefault();
            _this.close();
        };
        _this.handleKeyUp = function (e) {
            e.preventDefault();
            if (e.key === 'Escape') {
                _this.close();
            }
        };
        return _this;
    }
    BoardyDialog.prototype.render = function () {
        var _a = this.props, open = _a.open, title = _a.title, titleContent = _a.titleContent, actions = _a.actions, children = _a.children;
        var titleElement = (React.createElement("div", { style: styles.titleContainer },
            React.createElement("h4", { style: { color: '#fff', margin: '1rem' } }, title),
            titleContent,
            React.createElement(IconButton, { onClick: this.handleClose },
                React.createElement(FontIcon, { color: "white", className: "material-icons" }, "clear"))));
        return (React.createElement(Dialog, { onKeyUp: this.handleKeyUp, modal: false, open: open, actions: actions, bodyStyle: styles.body, titleStyle: styles.title, autoScrollBodyContent: true, className: "boardy-dialog", title: titleElement }, children));
    };
    return BoardyDialog;
}(React.Component));
export default BoardyDialog;



//////////////////
// WEBPACK FOOTER
// ./src/components/BoardyDialog.tsx
// module id = 174
// module chunks = 0